<template>
  <div class="topTis" :class="nowClass">
    <i
      class="el-icon-warning"
      style="color: #7B61FF; font-size: 14px"
      v-if="color == ''"
    ></i>
    <div class="desc">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "",
    },
    isNeedMarginLeft: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nowClass() {
      let className = "";
      if (this.color == "text") {
        className += "text-tip-box";
      }
      if (this.isNeedMarginLeft) {
        className += " margin-left-tip-8";
      }
      return className;
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.topTis {
  width: 100%;
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #f4f2ff;
  padding: 12px;
  color: #333;
  margin-bottom: 24px;
  .desc {
    display: inline-block;
    width: calc(100% - 30px);
    color: #666666;
    font-size: 12px;
    line-height: 22px;
    margin-left: 8px;
  }
}
.text-tip-box {
  padding: 0;
  width: fit-content;
  display: inline-flex;
  background: transparent;
  margin-bottom: 0;
  .desc {
    width: fit-content;
    color: #f89f39;
  }
}
.margin-left-tip-8 {
  margin-left: 8px;
}
.text-color-666 {
  color: #666 !important;
}
</style>
